module.exports = __webpack_public_path__ + "img/home_profile.2fc1bb22.png";